import { Resource as g } from "@coveo/platform-client";
const s = class s extends g {
  /**
   * @param organizationId The ID of the organization
   * @param numberOfDaysToInclude The number of days to include in the usage. Default is 7 days.
   * @returns The organization's endpoint usage
   */
  getEndpointUsage(t, e = 7) {
    return this.api.get(
      `${s.baseUrl}/${t}/endpoints/usage?numberOfDaysToInclude=${e}`
    );
  }
  /**
   * @param organizationId The ID of the organization
   * @returns The organization's region usage
   */
  getRegionUsage(t) {
    return this.api.get(
      `${s.baseUrl}/${t}/usage/regions`
    );
  }
  /**
   * @param organizationId The ID of the organization
   * @param params The parameters for the request
   * @returns The organization's search hub usage for the specified hostname
   */
  getSearchHubUsage(t, e) {
    return this.api.get(
      `${s.baseUrl}/${t}/search-hubs/usage?hostname=${e.hostname}&numberOfDaysToInclude=${e.numberOfDaysToInclude}&page=${e.page}&perPage=${e.perPage}`
    );
  }
};
s.baseUrl = "/rest/monitoring/global/organizations";
let a = s;
export {
  a as OrganizationMonitoringResource
};
//# sourceMappingURL=OrganizationMonitoringResource.js.map
